const privilegeMap = [
  {
    privilege: 'Manage 9999 Wafer & Silver Coin',
    keys: ['999 Wafer | Silver Coin'],
  },
  { privilege: 'Manage Retail Gold Price', keys: ['Retail Gold Price'] },
  {
    privilege: 'View Action History',
    keys: ['Action History'],
  },
  {
    privilege: 'Manage Manual Cut Off',
    keys: ['Price Feed', 'Manual Cut Off'],
  },
  {
    privilege: 'Manage Manual Price Override',
    keys: ['Price Feed', 'Manual Override'],
  },
  {
    privilege: 'Manage Circuit Breaker Setup',
    keys: ['Price Feed', 'Setups', 'Circuit Breaker Setup'],
  },
  {
    privilege: 'Manage Tomei Price Setup',
    keys: ['Price Feed', 'Setups', 'Tomei Price Setup'],
  },
  {
    privilege: 'View Feed Price History',
    keys: ['Price Feed', 'Reports', 'Feed Price Summary'],
  },
  {
    privilege: 'View Feed Price History',
    keys: ['Price Feed', 'Reports', 'Feed Price History'],
  },
  {
    privilege: 'View Circuit Breaker Setup History',
    keys: ['Price Feed', 'Reports', 'Circuit Breaker Setup History'],
  },
  {
    privilege: 'View Tomei Price History',
    keys: ['Price Feed', 'Reports', 'Tomei Price Summary'],
  },
  {
    privilege: 'View Tomei Price History',
    keys: ['Price Feed', 'Reports', 'Tomei Price History'],
  },
  {
    privilege: 'View Manual Price Activation History',
    keys: ['Price Feed', 'Reports', 'Manual Price Activation History'],
  },
  {
    privilege: 'View Cut Off History',
    keys: ['Price Feed', 'Reports', 'Feed Cut Off History'],
  },
  {
    privilege: 'View Application Log',
    keys: ['Application Log'],
  },
  {
    privilege: 'All',
    keys: [],
  },
];

export default privilegeMap;
